import { TooltipHost } from '@fluentui/react';
import React, { ForwardedRef, useEffect } from 'react';
import { useRef, useState } from 'react';
import styles from './PodMarketChips.module.scss';

interface ChipProps {
  text: string;
  className?: string;
}

const PodMarketChip = React.forwardRef(({text, className}: ChipProps, ref: ForwardedRef<HTMLDivElement>) => {
  return (
    <div ref={ref} className={`${styles.podMarketChip}${className ? ` ${className}` : ''}`}>
      {text}
    </div>
  );
});

interface Props {
  chips: string[];
  chipClassName?: string;
  noTruncate?: boolean;
}

const PodMarketChips = ({chips, chipClassName, noTruncate}: Props) => {
  const [isReady, setIsReady] = useState(false);
  const [shownChips, setShownChips] = useState<string[]>([]);
  const [hiddenChips, setHiddenChips] = useState<string[]>([]);

  let containerRef = useRef<HTMLDivElement>(null);
  const chipWidths: number[] = [];

  useEffect(() => {
    if (noTruncate) return;

    let containerWidth = containerRef.current?.getBoundingClientRect().width ?? 0;

    let totalWidth = 0;
    let cutoffIndex = 0;
    for (let chipCount = 0; chipCount < chips.length; chipCount++) {
      if (totalWidth + 8 + chipWidths[chipCount] > containerWidth - 24) {
        break;
      };
      totalWidth += chipWidths[chipCount] + 8;
      cutoffIndex = chipCount;
    }
      
    if (cutoffIndex >= chips.length - 1) {
      setShownChips(chips);
      setHiddenChips([]);
    } else {
      setShownChips(chips.slice(0, cutoffIndex));
      setHiddenChips(chips.slice(cutoffIndex));
    }
    setIsReady(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chips, noTruncate]);

  if (noTruncate) {
    return (
      <div className={`${styles.podMarketChipHolder} ${styles.noTruncate}`}>
        {chips.map((chip, i) => <PodMarketChip key={i} text={chip} />)}
      </div>
    )
  }

  return (
    <div className={styles.measurementWrapper} ref={containerRef}>
      <div className={`${styles.podMarketChipHolder} ${styles.measurement}`}>
        {chips.map((chip, i) => <PodMarketChip key={i} text={chip} ref={elem => {
          if (elem) chipWidths[i] = elem.getBoundingClientRect().width;
        }}/>)}
      </div>
      {isReady && (
        <div className={styles.podMarketChipHolder}>
          {shownChips.map((chip, i) => <PodMarketChip key={i} text={chip} />)}
          {hiddenChips.length > 0 && (
            <TooltipHost
              content={<div className={styles.overflowChipHolder}>
                {hiddenChips.map((chip, i) => <PodMarketChip key={i} text={chip} />)}
              </div>}
            >
              <PodMarketChip text={`+${hiddenChips.length}`} className={styles.secondaryChip} />
            </TooltipHost>
          )}
        </div>
      )}
    </div>
  );
};

export default PodMarketChips;